import TicketServer from "@/api/ticket";
import {WorkflowApiNew} from "../api/workflow/workflow";
import {draftSendWorkFlow} from '@/api/ticket/ticketRestructure/list.js'
import {Message} from 'element-ui'

//监控系统接入，接单作为首个节点时用
export async function requestAndAcceptIncident(ticket) {
    let workflowType = 'INCIDENT3';
    let currentStatus = 'WACCEPT';
    let business = {
        'bussiness': workflowType,
        'bussinessId': ticket.ticketuid,
        'params': JSON.stringify({
            'TICKETID': ticket.ticketid,
            'room_id': ticket.dcnum,
            'TITLE': ticket.description,
            'STATUS': currentStatus,
        }),
        "token": localStorage.getItem("token"),
        "appId": "WEB"
    };
    let reqRes = await WorkflowApiNew.request(business);
    let busineesId = reqRes.ownerId;
    let wfToken = reqRes.wfToken;
    let json = eval(reqRes.node_info.nextNodes);
    let nextNodeId = json[0].id;
    let jsonData = {
        'token': localStorage.getItem("token"),
        'appId': "WEB",
        'params': business.params,
        'nextNodeId': nextNodeId,
        'wfToken': wfToken
    }
    let submitParam = {
        "ticketUid": busineesId,
        "ticketid": ticket.ticketid,
        "status": currentStatus,
        "nextStatus": null,
        "level": null,
        "actualfinish": null,
        "createValidation": null,
        "createUser": [],
        "handleValidation": null,
        "handleUser": []
    }
    jsonData.dto = JSON.stringify(submitParam);
    return draftSendWorkFlow("/ticket/ticketToWorkFlowAudit/" + workflowType + "/" + busineesId, jsonData);
}

// 事件接单
export async function acceptIncident(ticket) {
    if(!this.ticketEntity.dcnum) {
        Message.warning('数据中心不能为空!');
        return
    }

    let workflowExtraParams = {
        room_id: ticket.dcnum,
        TITLE: ticket.description,
        TICKETID: ticket.ticketid,
    };
    let workflowParams = {
        bussiness: 'INCIDENT',
        bussinessId: ticket.ticketuid,
        params: JSON.stringify(workflowExtraParams),
        appId: 'WEB',
        token: window.localStorage.getItem('token'),
    };
    let ticketParams = {
        ticketUid: ticket.ticketuid,
        ticketid: ticket.ticketid,
        status: ticket.status,
        level: ticket.level,
        nextStatus: null,
        actualfinish: null,
        createValidation: null,
        createUser: [],
        handleValidation: null,
        handleUser: []
    };
    let body = JSON.parse(JSON.stringify(workflowParams));
    body.dto = JSON.stringify(ticketParams);
    return TicketServer.ticket.accept(ticket.ticketuid, body);
}
